import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChartmogulComponent } from './simple-icons-chartmogul.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChartmogulComponent ],
    exports:      [ SimpleIconsChartmogulComponent ],
    bootstrap:    []
})
export class SimpleIconsChartmogulModule {}
